// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14uzI","fullView":"styles_fullView__3Qm5b"};